"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBAPIProductMainUse", {
  enumerable: true,
  get: function get() {
    return _SVBAPIProductMainUse.default;
  }
});
var _SVBAPIProductMainUse = _interopRequireDefault(require("./src/SVBAPIProductMainUse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }